import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  e
} from "./chunk.D5EJUUKV.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/utilities/theme-detection.mixin.ts
function mixinThemeDetection(Base) {
  class ThemeChanger extends Base {
    connectedCallback() {
      super.connectedCallback();
      this.updateComplete.then(() => {
        document.addEventListener("theme-changed", ({ detail: { theme, mode } }) => {
          this.theme = theme;
          this.mode = mode;
        });
      });
      requestAnimationFrame(() => {
        const application = document.querySelector("fadv-application");
        if (!application)
          return;
        this.theme = application.theme;
        this.mode = application.mode;
      });
    }
    getThemeDefaults() {
      return;
    }
    handleThemeChange(_oldTheme, newTheme) {
      const defaultsMap = this.getThemeDefaults();
      if (!defaultsMap)
        return;
      const newThemeDefaults = defaultsMap[newTheme];
      if (!newThemeDefaults)
        return;
      Object.keys(newThemeDefaults).forEach((key) => {
        if (!this.hasAttribute(key)) {
          Object.assign(this, { [key]: newThemeDefaults[key] });
        }
      });
    }
  }
  __decorateClass([
    e()
  ], ThemeChanger.prototype, "theme", 2);
  __decorateClass([
    e()
  ], ThemeChanger.prototype, "mode", 2);
  __decorateClass([
    watch("theme")
  ], ThemeChanger.prototype, "handleThemeChange", 1);
  return ThemeChanger;
}

export {
  mixinThemeDetection
};
